import React, { FunctionComponent } from 'react';
import ICategoryAttributes from '../../../../model/ICategoryAttributes';
import IExtendedFeaturesList from '../../../../model/IExtendedFeaturesList';
import FeatureCategoryTitle from './featureCategoryTitle/FeatureCategoryTitle';
import featureCategoryTitleStyles from './featureCategoryTitle/featureCategoryTitleStyles';
import IFeature from '../../../../model/IFeature';
import { DisplayMode } from '../../../../enum/DisplayMode';
import getFeatureLayoutComponent from '../../../../service/getFeatureLayoutComponent';

export interface IFeatureCategoryProps {
  featuresList: IExtendedFeaturesList;
  categoryAttributes?: ICategoryAttributes;
  categoryName?: string;
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const FeatureCategoryLayoutDisplay: FunctionComponent<IFeatureCategoryProps> = ({
  featuresList,
  categoryAttributes,
  categoryName,
  openAccessoryDetailsModal,
}) => {
  const styles = featureCategoryTitleStyles();
  const LayoutComponent = getFeatureLayoutComponent(categoryAttributes.displaymode as DisplayMode);

  return (
    <>
      <FeatureCategoryTitle name={categoryName} classes={{ title: styles.title }} />
      <LayoutComponent
        featuresList={featuresList}
        categoryAttributes={categoryAttributes}
        data-test={`options:category:${categoryName}`}
        openAccessoryDetailsModal={openAccessoryDetailsModal}
      />
    </>
  );
};

export default FeatureCategoryLayoutDisplay;
